import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  private role = new BehaviorSubject<string>('');
  private accessRight = new BehaviorSubject<any[]>([]);
  private submodules = new BehaviorSubject<any[]>([]);

  currentRole = this.role.asObservable();
  currentAccessRights = this.accessRight.asObservable();
  currentSubmodules = this.submodules.asObservable();

  constructor() { }

  SetRole(role: string) {
    this.role.next(role);
  }


  setAccessRight(accessRight: any[]) {
    this.accessRight.next(accessRight);
  }

  setSubmodules(accessRight: any[]) {
    this.submodules.next(accessRight);
  }

  checkRight(role, module, rightlist: any[]) {
    if (role === 'Adminstrator' || role === 'Director') {
      return true;
    }
    else {
      const result = rightlist.find(r => r.module.toLowerCase() === module.toLowerCase());
      
      if (result) {
        return true;
      }
      else {
        return false;
      }
    }
  }

  checkPermission(role, module, rightlist: any[]) {
    if (role === 'Adminstrator' || role === 'Director') {
      return true;
    }
    else if (role !== 'Adminstrator' && role !== 'Director') {
      const result = rightlist.find(r => r.module.toLowerCase() === module.toLowerCase())
      if (result) {
        if (result.right === 'All') {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    }
  }
}
